import { render } from "./OrderDetailCompanyBusinessCard.vue?vue&type=template&id=67034046&scoped=true&ts=true"
import script from "./OrderDetailCompanyBusinessCard.vue?vue&type=script&lang=ts"
export * from "./OrderDetailCompanyBusinessCard.vue?vue&type=script&lang=ts"

import "./OrderDetailCompanyBusinessCard.vue?vue&type=style&index=0&id=67034046&lang=sass&scoped=true"
import "./OrderDetailCompanyBusinessCard.vue?vue&type=style&index=1&id=67034046&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67034046"]])

export default __exports__